<template>
  <!--渲染表单-->
  <el-form ref="form" class="process-form" label-position="top" :rules="rules" :model="_value">
    <div v-for="(item, index) in forms" :key="item.name + index" :class="item.perm == 'H' ? 'hide' : ''">
      <!-- style="display: none" -->
      <!-- {{ item }} <br />
      {{ _value }} <br />
      {{ _value[item.id] }} -->
      <el-form-item
        :prop="item.id"
        :label="item.title"
        v-if="item.name !== 'SpanLayout' && item.name !== 'Description'"
      >
        <form-design-render1
          :ref="`sub-item_${item.id}`"
          v-model="_value[item.id]"
          mode="PC"
          :config="item"
          :value="_value[item.id]"
          @input="input"
        />
      </el-form-item>
      <form-design-render1
        ref="span-layout"
        v-else
        v-model="_value"
        mode="PC"
        :config="item"
        :value="_value[item.id]"
      />
    </div>
  </el-form>
</template>

<script>
import FormDesignRender1 from '@/views/admin/layout/form/FormDesignRender1'

export default {
  name: 'FormRender1',
  components: { FormDesignRender1 },
  props: {
    forms: {
      type: Array,
      default: () => {
        return []
      },
    },
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      rules: {},
      // value: {},
    }
  },
  created() {
    console.log(this.value, 'this.value')
    console.log(this._value, 'this._value')
    console.log(this.forms, 'this.forms')
    // return;
    for (let i = 0; i < this.forms.length; i++) {
      const e = this.forms[i]
      this.$store.state.formValue[e.id] = e.value
      this._value[e.id] = e.value
    }
    // console.log(this.$store.state.formValue, "this.$store.state.formValue");
    // setTimeout(() => {
    // this._value = this.$store.state.formValue;
    console.log(this._value, 'this._value')
    console.log(this.value, 'this.value')
    this.loadFormConfig(this.forms)
    // }, 500);
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        console.log(val, 'Pval')
        console.log(this._value, '_value_value')
        this.$store.commit('setFormValue', this._value)
        this.$forceUpdate()
      },
    },
  },
  watch: {
    _value: {
      deep: true,
      handler(newVal, OldVal) {
        console.log(newVal, OldVal)
        // this.$emit("input", newVal);
        this.$store.commit('setFormValue', newVal)
      },
    },
  },
  methods: {
    input(val) {
      this._value = val
      console.log(this._value, 'PPval')
    },
    validate(call) {
      let success = true
      this.$refs.form.validate((valid) => {
        success = valid
        if (valid) {
          //校验成功再校验内部
          for (let i = 0; i < this.forms.length; i++) {
            if (this.forms[i].name === 'TableList') {
              let formRef = this.$refs[`sub-item_${this.forms[i].id}`]
              if (formRef && Array.isArray(formRef) && formRef.length > 0) {
                formRef[0].validate((subValid) => {
                  success = subValid
                })
                if (!success) {
                  break
                }
              }
            }
          }
        }
        call(success)
      })
    },
    loadFormConfig(forms) {
      forms.forEach((item) => {
        if (item.name === 'SpanLayout') {
          this.loadFormConfig(item.props.items)
        } else {
          this.$set(this._value, item.id, this.value[item.id])
          if (item.props.required) {
            this.$set(this.rules, item.id, [
              {
                type: item.valueType === 'Array' ? 'array' : undefined,
                required: true,
                message: `请填写${item.title}`,
                trigger: 'blur',
              },
            ])
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.process-form {
  /deep/ .el-form-item__label {
    padding: 0 0;
  }
}

.hide {
  display: none;
}
</style>
